// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nb-1";
export var messageSideRight = "_nb-2";
export var orderLookupBubbleContainer = "_nb-0";
export var submitButton = "_nb-3";